import {Link, Typography} from '@mui/material';
import {useNavigate} from 'react-router';

export interface FooterLinks {
  url: string;
  label: string;
}

export default function FooterLegal() {
  const navigate = useNavigate();

  const links: FooterLinks[] = [
    {label: 'Terms of Service', url: '/tos'},
    {label: 'Privacy Policy', url: '/privacy'},
  ];
  return (
    <>
      <Typography variant="h6" color="text.primary" gutterBottom>
        Legal
      </Typography>
      {links.map((l) => (
        <Link
          key={`FooterLegal-${l.label}`}
          component="button"
          onClick={() => navigate(l.url)}
          color="inherit"
          display="block"
          sx={{cursor: 'pointer'}}
        >
          {l.label}
        </Link>
      ))}
    </>
  );
}
